<template>
    <div id="mapa" ref="mapa">
        <MapKrpano v-if="this.use_map == 1" />
        <MapMosaico v-else-if="this.use_map == 2" />
        <MapSession v-else-if="!this.switch.validate_user" />
        <ModalOptins v-if="this.switch.validate_user" ref="modalOptins" />
    </div>
</template>

<script>
import {mapGetters,mapActions} from "vuex";
import MapMosaico from "@/components/pages/MapMosaico";
import MapSession from "@/components/pages/MapSession";
import ModalOptins from "@/components/Modals/ModalOptins.vue";
import MapKrpano from "@/components/pages/MapKrpano.vue";

export default {
    name: 'Map',
    components: {
        MapKrpano,
        ModalOptins,
        // MapButton,
        MapMosaico,
        MapSession,
    },
    data() {
        return {
            windowWidth: window.innerWidth,
            // test : false,
            modalFs: false
        }
    },
    computed: {
        ...mapGetters([
            'switch', "use_map",
        ]),
    },
    methods: {
        ...mapActions([]),
        onResize(){
            if (!this.$refs["mapa"])return;
            if(window.innerWidth>1000  && this.$app.$refs['copyright_footer']) {
                this.$refs["mapa"].style.height = `calc(100vh - ${this.$app.$refs['copyright_footer'].clientHeight}px)`;
                this.$app.$refs["copyright_footer"].style.position = `fixed`;
            }else {
                this.$refs["mapa"].style = "";
            }

        },
    },
    mounted() {

        let vm = this;
        vm.$nextTick(() => {
            this.onResize()
            window.addEventListener('resize', vm.onResize);
        })
        document.body.classList.remove('lms');
    },
    created()
    {
        /*
        console.log('LMS Map => ', this.lms);
        */
        // this.$app.LMSHandler(this.lms, 'map', '', '');
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.onResize);
    },
}
</script>

<style scoped lang="scss">
#mapa
{
    height: 100%;
    width: 100%;

    .fullscreen-button {
        position: absolute;
        width: 50px;
        height: 50px;
        top: 180px;
        left: 10px;

        background-color: #00000080;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 10px;
        cursor: pointer;

        .icon {
            color: #FFFFFF;
            font-size: 25px;
        }

        z-index: 10;
    }
}
@media screen and (max-width: 1000px) {
    #mapa
    {
        height: 100%;
        /*
        height: calc(100% - 45px);
        margin-top: 45px;
        */
    }
}
</style>
